import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

export const MaterialSpecificationsLoadingKeys = {
  create: "CREATE_MATERIAL",
  delete: "DELETE_MATERIAL",
  getMaterials: "GET_MATERIALS"
};

const initialState = {
  materials: [],
  loading: false,
  loadingKeys: [],
  error: null
};

// Async thunks
export const getMaterialsById = createAsyncThunk(
  'materialSpecifications/getMaterialsById',
  async ({ id }, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(`/api/v1/materials/${id}`);
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to get materials');
    }
  }
);

export const createMaterials = createAsyncThunk(
  'materialSpecifications/create',
  async ({ creationData }, { rejectWithValue, dispatch }) => {
    try {
        const { id, newMaterials } = creationData
        const { data } = await axios.post('/api/v1/materials', { newMaterials });
        dispatch(getMaterialsById({ id }));
        return data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to create material');
    }
  }
);

export const deleteMaterial = createAsyncThunk(
  'materialSpecifications/delete',
  async ({ id, idToDelete }, { rejectWithValue, dispatch }) => {
    try {
      await axios.delete(`/api/v1/materials/${idToDelete}`);
      dispatch(getMaterialsById({ id }));
      return id;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to delete material');
    }
  }
);

const materialSpecificationsSlice = createSlice({
  name: 'materialSpecifications',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getMaterialsById.pending, (state) => {
        state.loading = true;
        state.loadingKeys = [...state.loadingKeys, MaterialSpecificationsLoadingKeys.getMaterials];
      })
      .addCase(getMaterialsById.fulfilled, (state, action) => {
        state.loading = false;
        state.materials = action.payload?.data || [];
        state.error = null;
        state.loadingKeys = state.loadingKeys.filter(key => key !== MaterialSpecificationsLoadingKeys.getMaterials);
      })
      .addCase(getMaterialsById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.loadingKeys = state.loadingKeys.filter(key => key !== MaterialSpecificationsLoadingKeys.getMaterials);
      })
      .addCase(createMaterials.pending, (state) => {
        state.loading = true;
        state.loadingKeys = [...state.loadingKeys, MaterialSpecificationsLoadingKeys.create];
      })
      .addCase(createMaterials.fulfilled, (state) => {
        state.loading = false;
        state.error = null;
        state.loadingKeys = state.loadingKeys.filter(key => key !== MaterialSpecificationsLoadingKeys.create);
      })
      .addCase(createMaterials.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.loadingKeys = state.loadingKeys.filter(key => key !== MaterialSpecificationsLoadingKeys.create);
      })
      .addCase(deleteMaterial.pending, (state) => {
        state.loading = true;
        state.loadingKeys = [...state.loadingKeys, MaterialSpecificationsLoadingKeys.delete];
      })
      .addCase(deleteMaterial.fulfilled, (state) => {
        state.loading = false;
        state.error = null;
        state.loadingKeys = state.loadingKeys.filter(key => key !== MaterialSpecificationsLoadingKeys.delete);
      })
      .addCase(deleteMaterial.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.loadingKeys = state.loadingKeys.filter(key => key !== MaterialSpecificationsLoadingKeys.delete);
      });
  }
});

export const {} = materialSpecificationsSlice.actions;
export default materialSpecificationsSlice.reducer; 